import { Action } from '@ngrx/store';
import {Module} from '../../my-features/module/module.model';

export enum UserModuleActionTypes {
  GetUserModlues = '[UserModule]  Get UserModules',
  LoadUserModules = '[UserModule] Load UserModules'
}

export class GetUserModules implements Action {
  readonly type = UserModuleActionTypes.GetUserModlues;
  constructor(public payload: any = null ) {}
}

export class LoadUserModules implements Action {
  readonly type = UserModuleActionTypes.LoadUserModules;
  constructor(public payload: Module[] ) {}
}


export type UserModuleActions = LoadUserModules
  | GetUserModules;
